import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-6xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Gizlilik Politikası</h1>
      <p className="mb-4">
        HALISAHABUL olarak, kullanıcılarımızın gizliliğini önemsiyoruz. Bu
        gizlilik politikası, sitemizi kullanırken hangi bilgileri topladığımızı,
        nasıl kullandığımızı ve koruduğumuzu açıklamaktadır.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Toplanan Bilgiler</h2>
      <p className="mb-4">
        Hizmetlerimizi kullanırken adınız, e-posta adresiniz, telefon numaranız
        ve IP adresiniz gibi bazı kişisel bilgileri toplayabiliriz.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Bilgilerin Kullanımı</h2>
      <p className="mb-4">
        Toplanan bilgiler, rezervasyon işlemleri, müşteri hizmetleri ve site
        güvenliği gibi amaçlarla kullanılmaktadır.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Çerezler (Cookies)</h2>
      <p className="mb-4">
        Sitemiz, kullanıcı deneyimini geliştirmek için çerezleri kullanabilir.
        Tarayıcı ayarlarınızdan çerezleri yönetebilirsiniz.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Bilgi Paylaşımı</h2>
      <p className="mb-4">
        Kişisel bilgileriniz, yasal gereklilikler dışında üçüncü kişilerle
        paylaşılmamaktadır.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">
        Gizlilik Politikası Güncellemeleri
      </h2>
      <p className="mb-4">
        Bu gizlilik politikası zaman zaman güncellenebilir. Değişikliklerden
        haberdar olmak için bu sayfayı düzenli olarak kontrol ediniz.
      </p>

      <p className="mt-6">Son Güncelleme: {new Date().toLocaleDateString()}</p>
    </div>
  );
};

export default PrivacyPolicy;
